// --- About Us Section ---
import { motion } from "framer-motion";
import { Users, Target, Award, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

function AboutSection() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-white to-indigo-50 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-[-10%] left-[5%] w-72 h-72 bg-indigo-300 opacity-20 blur-3xl rounded-full" />
        <div className="absolute bottom-[-10%] right-[5%] w-96 h-96 bg-purple-300 opacity-20 blur-3xl rounded-full" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl font-extrabold text-gray-900 mb-6"
        >
          About <span className="text-indigo-600">Us</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="text-gray-600 max-w-2xl mx-auto mb-14"
        >
          We help professionals, students, and businesses build powerful online
          presences that attract opportunities. Our expert team crafts optimized
          LinkedIn profiles, resumes, and personal brands that stand out in the
          digital space.
        </motion.p>

        {/* About Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: Users,
              title: "Experienced Team",
              text: "Our experts come from recruitment, branding, and design backgrounds.",
            },
            {
              icon: Target,
              title: "Goal-Driven Approach",
              text: "Every project is tailored to your career and visibility goals.",
            },
            {
              icon: Award,
              title: "Proven Results",
              text: "Over 5,000+ professionals transformed their careers with our help.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2, duration: 0.6 }}
              className="bg-white/80 backdrop-blur-xl border border-indigo-100 rounded-3xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 p-8"
            >
              <item.icon className="w-10 h-10 text-indigo-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.text}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-14"
        >
          <Link
            to="/aboutuS"
            className="inline-flex items-center bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-full shadow-lg hover:shadow-indigo-300/40 hover:scale-[1.03] transition-all font-medium"
          >
            See More Details
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}

export default AboutSection;
